import React from 'react';
import {t} from '@lingui/core/macro';

import TextAreaDomain from 'shared/ui/TextArea/TextAreaDomain';
import {NotifyChannels} from 'entities/notification';
import {IMassOperationAction} from 'shared/ui/MassOperations/MassOperations';
import {EditableFieldRow, MonitorBatchOperationsForm} from 'entities/monitor';
import useDomainMonitorBatchOperationsForm from 'features/domain/model/useDomainMonitorBatchOperationsForm';
import {DOMAIN_BATCH_EDIT_FIELDS, DOMAIN_BATCH_EDIT_FIELD_BY_KEY} from 'features/domain/lib/domainBatchEditFields';

import DomainMonitorChecks from './DomainMonitorChecks/DomainMonitorChecks';

interface IDomainMonitorBatchOperationsFormProps {
    handleClose: () => void,
    action?: IMassOperationAction,
    onSuccess?: () => void,
}

const DomainMonitorBatchOperationsForm: React.FC<IDomainMonitorBatchOperationsFormProps> = ({
    handleClose,
    action,
    onSuccess,
}) => {
    const state = useDomainMonitorBatchOperationsForm({actionValue: action?.value, handleClose, onSuccess});
    const {form, removeField} = state;
    const {register, formState, control} = form;
    const {errors} = formState;

    const renderEditField = (key: string) => {
        if (key === 'notify') {
            return (
                <EditableFieldRow
                    key={key}
                    label={DOMAIN_BATCH_EDIT_FIELD_BY_KEY.notify.label()}
                    onRemove={() => removeField(key)}
                >
                    <NotifyChannels
                        control={control}
                        register={register}
                        emailFieldName="notify_by_email"
                        additionalEmailsFieldName="additional_emails"
                        telegramFieldName="telegram_chats"
                        maxFieldName="max_chats"
                    />
                </EditableFieldRow>
            );
        }

        return (
            <EditableFieldRow key={key} onRemove={() => removeField(key)}>
                <DomainMonitorChecks register={register} activeKeys={[key]}/>
            </EditableFieldRow>
        );
    };

    return (
        <MonitorBatchOperationsForm
            action={action}
            state={state}
            edit={{fields: DOMAIN_BATCH_EDIT_FIELDS, renderField: renderEditField}}
            selectedLabel={t`Выбрано мониторов доменов`}
            exportCountLabel={t`Экспортировано мониторов доменов`}
            removeByList={{
                label: t`Домены`,
                hint: t`Удалятся все мониторы, домены которых есть в списке.`,
                error: errors?.url?.message,
                field: (
                    <TextAreaDomain
                        rows={5}
                        register={register}
                        placeholder={t`Вводите каждый домен с новой строки`}
                        name="url"
                    />
                ),
            }}
        />
    );
};

export default DomainMonitorBatchOperationsForm;
